import React from 'react';
import './AuthLoadingScreen.css';

export default function AuthLoadingScreen() {
  return (
    <div className="auth-loading-screen" role="status" aria-live="polite">
      <div className="auth-loading-screen__spinner" aria-hidden="true" />
      <span className="visually-hidden">Loading</span>
    </div>
  );
}
